import React from "react";
import contact_us from "../../assests/img/contact-us.jpg";
import { Card, Col, Row } from "react-bootstrap";
import sample_date from "../../assests/img/Asset 30.svg";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Helmet } from "react-helmet-async";

const ContactUs = () => {
  return (
    <>
      {/* ================= SEO META TAGS ================= */}
      <Helmet>
        <title>
          Trusted Pathology Lab in Punjab & Certified MRI Centers – Kior
          Healthcare
        </title>

        <meta
          name="description"
          content="Kior Healthcare is a trusted pathology lab in Punjab and certified MRI center in Mohali. Contact us to book lab tests, MRI scans, and health checkup packages."
        />

        <meta
          name="keywords"
          content="Trusted Pathology Lab in Punjab, Certified MRI Centers in Mohali, Pathology Lab Near Me, MRI Scan Mohali, Diagnostic Center Punjab"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* ================= PAGE WRAPPER ================= */}
      <section className="contact_us">
        {/* ================= BANNER ================= */}
        <img src={contact_us} alt="Contact Kior Healthcare" />

        {/* ================= INTRO CONTENT ================= */}
        <section className="contact_intro py-5">
          <div className="coustom_container">
            <h1>Kior Healthcare – Your Trusted Pathology Lab in Punjab</h1>

            <p>
              <strong>Kior Healthcare</strong> is a leading and{" "}
              <strong>trusted pathology lab in Punjab</strong>, offering
              precise, reliable, and timely diagnostic services for patients
              across Mohali and surrounding regions. Our commitment to accuracy,
              safety, and compassionate patient care makes us one of the most
              dependable healthcare providers in the region.
            </p>

            <p>
              We also operate <strong>certified MRI centers in Mohali</strong>,
              equipped with advanced imaging technology to support accurate
              diagnosis and informed medical decisions.
            </p>

            <h4>Reach Out to Our Experts</h4>
            <p>
              Whether you need routine lab tests, advanced imaging, or complete
              health checkup packages, our team is always ready to assist you.
              Every test at Kior Healthcare is handled with precision and
              delivered on time.
            </p>

            <h4>Book Your Appointment Online</h4>
            <p>
              Easily schedule your lab tests, MRI scans, or wellness packages
              online or via phone. Our diagnostic services are designed to
              deliver fast, accurate, and safe results.
            </p>

            <ul>
              <li>Blood Tests & Advanced Health Panels</li>
              <li>MRI & Diagnostic Imaging Services</li>
              <li>Full Body Checkups & Wellness Packages</li>
            </ul>
          </div>
        </section>

        {/* ================= CONTACT INFO CARDS ================= */}
        <div className="coustom_container pb-5">
          <Row className="gy-4">
            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={sample_date} alt="Location" />
                  </div>

                  <Card.Title className="mt-3">Our Location</Card.Title>
                  <Card.Text>
                    C-210 P, Phase 8-B
                    <br />
                    Industrial Area
                    <br />
                    Mohali, Punjab
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={sample_date} alt="Working Hours" />
                  </div>

                  <Card.Title className="mt-3">Working Hours</Card.Title>
                  <Card.Text>
                    Monday – Saturday
                    <br />
                    8:00 AM – 8:00 PM
                  </Card.Text>
                  <Card.Text>
                    Sunday
                    <br />
                    9:00 AM – 4:00 PM
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={sample_date} alt="Contact" />
                  </div>

                  <Card.Title className="mt-3">Contact Us</Card.Title>
                  <Card.Text>+91 8263000004</Card.Text>
                  <Card.Text>+91 9875964159</Card.Text>
                  <Card.Text>kiorhealthcare8b@gmail.com</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* ================= GOOGLE MAP ================= */}
        <div className="map_wrapper">
          {/* <LoadScript googleMapsApiKey="AIzaSyDDJCBarnoBvgH6ZvLBIBL0YVFYEXqm8-M"> */}
          <LoadScript googleMapsApiKey="AIzaSyBl2i9Wu6bJdKYrSXWA_smOVdrugLnbzo0">
            <GoogleMap
              mapContainerStyle={{ width: "100%", height: "400px" }}
              center={{ lat: 30.7076, lng: 76.6855 }}
              zoom={20}
            >
              <Marker position={{ lat: 30.7076, lng: 76.6855 }} />
            </GoogleMap>
          </LoadScript>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
